import Vue from 'vue'
// @ts-ignore
import App from './App.vue'
import store from '../store'
import pkg from '../../package.json'
import router from './router'

Vue.config.productionTip = false

console.log('UMG Listening Party App', pkg.version)

const create = (obj: object): Vue => new Vue(obj)

declare global {
  interface Window {
    lio?: { _uid: string };
    dataLayer: any[];
    cmp_block_ignoredomains: string[];
  }
}

window.cmp_block_ignoredomains = ['sdk.scdn.co', 'js-cdn.music.apple.com']

create({
  el: '#app',
  components: { App },
  store,
  router
})
